import React, { useEffect, useRef, useState } from "react";
import "./header_ICor.css";
import { useTranslation } from "react-i18next";

import idea from "../../../assets/img/ideaCort_min.png";
import FondoIdeasMobile from "../../../assets/img/FondoIdeas.svg";

const Header_ICor = () => {

  const [t] = useTranslation("ideaCorta");
  const [isMobile, setIsMobile] = useState(false);

  const handleWindowResize = () => {
    const width = window?.innerWidth;
    if (width <= 820) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  
  return (
    <div className="ideas-cort">
      <div className="contenedor">
        <div className="row1">
          <div className="col1"></div>
          <div className="col2 fade-in-fwd">
            <div className="textContainer">
              <p className="titleContainer">
                {t("ideaCort.tit1")} <b>{t("ideaCort.tit2")}</b>
              </p>
              <p className="esp-tit-s">
                {t("ideaCort.desc1")} <b>{t("ideaCort.desc2")}</b> {t("ideaCort.desc3")} <b>{t("ideaCort.desc4")}</b> {t("ideaCort.desc5")}
              </p>
            </div>
          </div>
          {!isMobile && (
            <img src={idea} alt="Imagen ideas" className="backgroundImage" />
          )}
          {isMobile && (
            <img src={FondoIdeasMobile} alt="Imagen ideas" className="backgroundImage" />
          )}
        </div>
      </div>
    </div>
  );
};
export default Header_ICor;
